import styled from 'styled-components';

export const SurveyList = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #E9E9F5;
  align-items: center;
  .toolbar {
    margin-top: 20px;
    border: 2px solid #FFFFFF;
    border-radius: 20px;
    padding: 10px;
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    &__left {
      display: flex;
      align-items: center;
    }
    &__right {
      display: flex;
      align-items: center;
    }
    .select-container {
      display: flex;
      align-items: center;
      &__label {
        font-family: Nunito Sans Bold;
        font-size: 15px;
        margin-right: 10px;
        white-space: nowrap;
        color: #1F1F52;
      }
    }
    .select-separator {
      height: 14px;
      border-right: 1px solid #3E3E5B;
      margin: 0 20px;
    }
  }

  .section {
    border-bottom: 2px solid #FFFFFF;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    &__content {
      width: 90%; 
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 10px 0;
    }
    .all-surveys-quantity {
      font-size: 17px;
      color: #3E3E5B;
    }
    .survey-answered-filter {
      color: #1F1F52;
      font-size: 17px;
      padding: 10px 15px;
      background-color: #FFFFFF;
      border-radius: 14px;
      display: flex;
      align-items: center;
      &__text {
        margin-right: 10px;
      }
    }
  }

  .surveys-section {
    height: calc(100% - 165px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    margin: 10px 0px 0px; 
    box-sizing: border-box;
    align-items: center;
    width: 100%;
    .survey-list {
      width: 90%;
      &__no-more{
        font-family: Nunito Sans;
        font-size: 15px;
        text-align: center;
        color: #707582;
        margin: 40px;
      }
      &__reaction {
        margin: auto;
      }
      .survey-item {
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        display: flex;
        margin-bottom: 20px;
        background-color: #F2F2F7;
        box-shadow: 0px 3px 9.5px 1px #9395CC24;
        border: 2px solid var(--base-White-I, #FFFFFF);
        border-radius: 20px;
        margin-bottom: 20px;
        &__separator {
          height: 14px;
          margin: 0 20px;
          border-right: 1px solid var(--Backgrounds-Separador-I, #CFD3DD);
        }
        &__info {
          width: 350px;
          display: flex;
          &-icon {
            font-size: 15px;
            color: #FFFFFF;
            align-items: center;
          }
          &-icon-container {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 5px;
            box-shadow: 0px 0px 8.63px 0px #DADAF6;
            background: #2A28D6;
            border: 1.07px solid #FFFFFF;
            justify-content: center;
            display: flex;
          }
        }
        &__center {
          min-width: 250px;
          &-top {
            display: flex;
            align-items: center;
          }
          &-separator {
            height: 8.5px;
            margin: 0 10px;
            border-right: 1px solid var(--Backgrounds-Separador-I, #CFD3DD)
          }
        }
        &__info {
          &-title {
            font-family: Nunito Sans Bold;
            font-size: 16px;
            color: #1F1F52;
          }
          &-date {
            font-family: Nunito Sans;
            font-size: 16px;
            color: #707582;
          }
        }
        &__number-sendings {
          font-family: Nunito Sans;
          font-size: 14px;
          color: #1F1F52;
        }
        &__number-answers {
          font-family: Nunito Sans;
          font-size: 14px;
          color: #1F1F52;
        }
        &__delicate-results {
          margin-top: 10px;
          display: flex;
          background-color: #FFFFFF;
          border-radius: 5px;
          padding-right: 10px;
          align-items: center;  
          width: fit-content;
          &-icon {
            width: 9px;
            height: 9px;
            border-radius: 50%;
            display: flex;
            margin: 4px 7px 4px 4px;
            background-color: #CFD3DD;
            border: 1px solid #DFE1E6;
            &--alert {
              border: 1px solid #FAB031;
              background-color: #FAB031;
            }
          }
          &-text {
            font-family: Nunito Sans;
            font-size: 16px;
            color: #707582;
            &--alert {
              color: #1F1F52;
            }
          }
        }
        &__buttons {
          display: flex;
          align-items: center;
          & > * {
            margin-left: 10px;
          }
        }
      }
    }
  }
`